import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      alertSetting: {
        ALERT_SETTINGS: 'Alert Settings',
        BACK_TO_ALERT_LIST: 'Back to Alert List',
        DISABLE_EMAILS: 'Disable Emails',
        DISABLE_EMAILS_CONFIRM: 'Are your sure you want to disable emails?',
        DISABLE_ALERTS: 'Disable Alerts',
        EMAIL_SETTINGS: 'Email Settings',
        CONFIGUE_EMAIL_SETTINGS_FOR_ALERTS:
          'Configue email settings for Alerts',
        ALERT_EMAIL: 'Alert Email',
        ALERT_EMAIL_DESC:
          'Each alert will be notified via email as soon as it occurs. You can specify which events and financial alerts you want to be notified about via email in the settings below.',
        ALERT_EMAIL_DIGEST: 'Alert Email Digest',
        ALERT_EMAIL_DIGEST_DESC:
          'You will only receive one email inform the total number of alerts that occur during the day.',
        INDUSTRY_AND_MACRO_SETTINGS: 'Industry and Macroeconomic Alerts',
        INDUSTRY_ALERTS: 'Industry Alerts',
        INDUSTRY_ALERTS_DESC:
          'Enable industry alert to receive update on news about your interested industries. To view your interested industries, click',
        INDUSTRY_ALERTS_DESC2: 'Preferences & Settings',
        DISABLE_ALERTS_INDUSTRY:
          'Are you sure you want to turn off Alerts for Industry?',
        MACROECONOMIC_ALERTS: 'Macroeconomic Alerts',
        MACROECONOMIC_ALERTS_DESC:
          'Enable Macroeconomic alert to receive updates on Vietnam Economy.',
        SEND_EMAILS: 'Send emails',
        DISABLE_ALERTS_MACRO:
          'Are you sure you want to turn off Alerts for Macroeconomic?',
        DISABLE_EMAIL_TOOLTIP_1: 'To continue receiving email,<br />please',
        DISABLE_EMAIL_TOOLTIP_2: 'click here',
        DISABLE_EMAIL_TOOLTIP_3: 'and enable email settings.',
        COMPANY_ALERTS: 'Company Alerts',
        COMPANY_ALERT_NOTE:
          'Configure alert profile to stay informed of changes affecting companies in your portfolios.',
        CREATE_ALERT_PROFILE: 'Create Alert Profile',
        UPGRADE: 'Upgrade',
        UPGRADE_ACCOUNT_TO_CREATE_PROFILE:
          ' your account to create a new alert profile',
        PROFILE_NAME: 'Profile Name',
        PROFILE_NAME_RULES: 'Profile Name Rules',
        PROFILE_ALERT_NAME_REQUIRED: 'Please fill in all required fields.',
        PROFILE_ALERT_NAME_EXIST:
          'This name already exists. Please enter a difference name.',
        PORTFOLIO: 'Portfolio',
        ENABLE_EMAIL: 'Enable Emails',
        DELETE_PROFILE_TITLE: 'Delete',
        DELETE_PROFILE_MESS: 'Are you sure you want to delete "%{name}"?',
        DELETE_PROFILES_MESS:
          'Are you sure you want to delete %{count} profiles?',
        TOOLTIP_FOLLOWING_PROFILE:
          'The Following List is a special portfolio with a distinct set of alert conditions that can be applied to the companies in this list.',
        NEW_ALERT_PROFILE: 'New Alert Profile',
        ENABLE_EMAILS: 'Enable Emails',
        ENABLE_EMAILS_DESC:
          'Alerts will be delivered online and via e-mail by default. All emails for this profile can be disabled here. Emails for specific scores or events can be enabled or disabled below.',
        CREATE_A_NEW_ALERT_PROFILE: 'Create a new Alert Profile',
        CREATE_FROM_EXISTING_PROFILE: 'Create from existing profile',
        EVENT_RULES: 'Event Rules',
        EVENT_RULES_NOTE: 'Alert me if any of these events occur.',
        EVENT: 'Event',
        CHANGE_ALL: 'Changes',
        CHANGE_ACTIVE_TO_OTHERS: 'Changes from Active Status to Others',
        CHANGE_ANY_TO_ACTIVE: 'Changes from any status to Active',
        SCORE_RULES: 'Score Rules',
        SCORE_RULES_NOTE: 'Alert me if any of these score conditions are met.',
        SCORE: 'Score',
        CONDITION: 'Condition',
        THRESHOLD: 'Threshold',
        DECREASE_TO: 'Decrease to',
        INCREASE_TO: 'Increase to',
        GOES_ABOVE: 'Goes Above',
        GOES_BELOW: 'Goes Below',
        CHANGES: 'Changes',
        DECREASE_IN_VALUE: 'Decrease in value',
        INCREASE_IN_VALUE: 'Increase in value',
        CHANGES_IN_VALUE: 'Changes in value',
        CREDIT_ANY_LEVEL: 'Any level',
        VERY_LOW_RISK: 'Very Low Risk',
        LOW_RISK: 'Low Risk',
        MODERATE_RISK: 'Moderate Risk',
        SIGNIFICANT_RISK: 'Significant Risk',
        AGRESSIVE_RISK: 'Agressive Risk',
        PERFORMANCE_ANY_LEVEL: 'Any level',
        HIGH_GROWTH: 'High Growth potential',
        DECENT_GROWTH: 'Decent Growth potential',
        MODEST_GROWTH: 'Modest Growth potential',
        INSIGNIFICANT_GROWTH: 'Insignificant Growth potential',
        FINANCIAL_RULES: 'Financial Rules',
        FINANCIAL_RULES_NOTE:
          'Alert me if any of these financial conditions are met.',
        FINANCIAL_INDICATOR: 'Financial Indicator',
        APPLY_TO_PORTFOLIOS: 'Apply to Portfolios',
        APPLY_TO_PORTFOLIOS_NOTE:
          'Select one or more portfolios you want to apply this alert profile.',
        PORTFOLIOS: 'Portfolios',
        SELECT_PORTFOLIO: 'Select Portfolio',
        SEARCH_PORTFOLIOS_PLH: 'Search / Find Portfolio Name',
        SELECTED: 'selected',
        BACK_TO_ALERT_SETTING: 'Back to Alert Settings',
        FOLLOWING_LIST_ALERT_NOTE:
          'The Following List is a special portfolio with a distinct set of alert conditions that can be applied to the companies in this list. This set of criteria does not apply to other portfolios.',
        TRACK_COMPANY_RULES: 'Track company rules',
        TRACK_COMPANY_RULES_NOTE:
          'Enable or disable Email Alerts. If you disable Emails, you will continue to receive alerts online, in-solution.',
        VIEW_ALL_COMPANY_FOLLOWING: 'To view all companies you are following, ',
        CLICK_HERE: 'click here.',
        criteria: {
          FINANCIAL_DISTRESS: 'Financial Distress',
          BANKRUPTCY: 'Bankruptcy',
          FILING_STATUS: 'Filing Status',
          ANALYSIS_AND_CREDIT_RATINGS: 'Analysis and Credit Ratings',
          BUSSINESS_DISRUPTION: 'Business Disruption',
          LAWSUIT: 'Lawsuit',
          LEGAL_VIOLATIONS: 'Legal Violations',
          MANAGEMENT_CHANGES: 'Management Changes',
          CAPITAL_AND_OWNERSHIP_CHANGES: 'Capital & Ownership',
          EARNING_ANNOUNCEMENT: 'Earnings announcement',
          YEARS_OF_OPERATION: 'Enterprise Status',
          CORPORATE_CREDIT_RISK_SCORE: 'Corporate Credit Risk Score',
          CORPORATE_PERFORMANCE_SCORE: 'Corporate Performance Score',
          TRADE_CREDIT_LIMIT_RECOMMENDATION:
            'Trade Credit Limit Recommendation',
          REVENUE_OPERATION_INCOME: 'Revenue & Operating Income',
          PROFIT_BEFORE_TAX: 'Profit Before Tax',
          CHANGE_NAME: 'Change of Name/Tax Code/Location/ Registered Industry',
          CHANGE_LEGAL_FORM: 'Change of Legal Form',
          CHANGE_LEGAL_REPRESENTATIVE: 'Change of Legal Representative',
          CHANGE_ACCOUNTING_PERIOD: 'Change of Fiscal Year',
          UPDATE_FINANCIAL_STATEMENT: 'Update of Financial Statement',
        },
        PORTFOLIO_TOOLTIP: 'Set Profile to Portfolio',
        SAVE_CHANGES: 'Save Changes',
        SAVE_CHANGES_CONFIRM_MESS:
          'Do you want to save changes to the current alert profile?',
        WARNING_NO_CRITERIA: 'Please enable criteria for Alert Profile.',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      alertSetting: {
        ALERT_SETTINGS: 'Cài đặt cảnh báo',
        BACK_TO_ALERT_LIST: 'Trở về Danh sách cảnh báo',
        DISABLE_EMAILS: 'Ngừng nhận email',
        DISABLE_EMAILS_CONFIRM: 'Bạn muốn ngừng nhận email cảnh báo?',
        DISABLE_ALERTS: 'Ngừng nhận cảnh báo',
        EMAIL_SETTINGS: 'Cài đặt Email',
        CONFIGUE_EMAIL_SETTINGS_FOR_ALERTS: 'Cài đặt Email cho cảnh báo',
        ALERT_EMAIL: 'Email cảnh báo',
        ALERT_EMAIL_DESC:
          'Mỗi cảnh báo sẽ được gửi Email ngay sau khi có sự kiện xảy ra. Bạn có thể nhận cảnh báo về sự kiện, tài chính mà bạn muốn bằng cách cài đặt Email bên dưới.',
        ALERT_EMAIL_DIGEST: 'Email cảnh báo chung',
        ALERT_EMAIL_DIGEST_DESC:
          'Bạn chỉ nhận được một Email thông báo tổng số cảnh báo được thống kê trong ngày.',
        INDUSTRY_AND_MACRO_SETTINGS: 'Cảnh báo ngành và nền kinh tế vĩ mô',
        INDUSTRY_ALERTS: 'Cảnh báo ngành',
        INDUSTRY_ALERTS_DESC:
          'Bật cảnh báo ngành để nhận thông tin cập nhật về các ngành mà bạn quan tâm. Để xem các ngành bạn quan tâm, hãy nhấp vào',
        INDUSTRY_ALERTS_DESC2: 'Tùy chọn và cài đặt',
        DISABLE_ALERTS_INDUSTRY: 'Bạn muốn tắt các cảnh báo về Ngành?',
        MACROECONOMIC_ALERTS: 'Cảnh báo nền kinh tế vĩ mô',
        MACROECONOMIC_ALERTS_DESC:
          'Nhận cảnh báo cho các thông tin kinh tế vĩ mô.',
        SEND_EMAILS: 'Gửi email',
        DISABLE_ALERTS_MACRO: 'Bạn muốn tắt các cảnh báo vể Kinh tế vĩ mô?',
        DISABLE_EMAIL_TOOLTIP_1: 'Để tiếp tục nhận Email,<br />vui lòng',
        DISABLE_EMAIL_TOOLTIP_2: 'nhấp tại đây',
        DISABLE_EMAIL_TOOLTIP_3: 'và bật cài đặt email.',
        COMPANY_ALERTS: 'Cảnh báo của công ty',
        COMPANY_ALERT_NOTE:
          'Cài đặt quy tắc cảnh báo để cập nhật các thay đổi liên quan đến công ty bạn quan tâm.',
        CREATE_ALERT_PROFILE: 'Thêm Quy Tắc Cảnh Báo',
        UPGRADE: 'Nâng cấp',
        UPGRADE_ACCOUNT_TO_CREATE_PROFILE:
          ' tài khoản của bạn để tạo bộ quy tắc cảnh báo mới',
        PROFILE_NAME: 'Tên Bộ Quy Tắc',
        PROFILE_NAME_RULES: 'Bộ quy tắc',
        PROFILE_ALERT_NAME_REQUIRED: 'Vui lòng điền vào trường bắt buộc',
        PROFILE_ALERT_NAME_EXIST:
          'Tên này đã tồn tại. Vui lòng nhập lại tên khác.',
        PORTFOLIO: 'Danh Mục',
        ENABLE_EMAIL: 'Nhận Email',
        DELETE_PROFILE_TITLE: 'Xóa cảnh báo',
        DELETE_PROFILE_MESS: 'Bạn muốn xóa "%{name}"?',
        DELETE_PROFILES_MESS: 'Bạn muốn xóa %{count} bộ quy tắc?',
        TOOLTIP_FOLLOWING_PROFILE:
          'Danh sách theo dõi là một danh mục đặc biệt với tập hợp các điều kiện cảnh báo riêng biệt, dùng để áp dụng cho các doanh nghiệp trong danh sách này.',
        NEW_ALERT_PROFILE: 'Quy tắc cảnh báo mới',
        ENABLE_EMAILS: 'Nhận Email',
        ENABLE_EMAILS_DESC:
          'Cảnh báo sẽ được gửi trực tuyến và qua email theo mặc định. Ngừng nhận email tại đây. Tùy chỉnh nhận email cho điểm số hoặc sự kiện cụ thể bên dưới.',
        CREATE_A_NEW_ALERT_PROFILE: 'Thêm một quy tắc cảnh báo mới',
        CREATE_FROM_EXISTING_PROFILE: 'Thêm từ bộ quy tắc sẵn có',
        EVENT_RULES: 'Quy tắc sự kiện',
        EVENT_RULES_NOTE: 'Nhận thông báo về các sự kiện dưới đây.',
        EVENT: 'Sự kiện',
        CHANGE_ALL: 'Mọi thay đổi',
        CHANGE_ACTIVE_TO_OTHERS: 'Thay đổi từ Hoạt động sang trạng thái khác',
        CHANGE_ANY_TO_ACTIVE: 'Thay đổi sang trạng thái Hoạt động',
        SCORE_RULES: 'Quy tắc điểm',
        SCORE_RULES_NOTE:
          'Nhận thông báo khi các điều kiện về điểm số được đáp ứng.',
        SCORE: 'Điểm',
        CONDITION: 'Điều kiện',
        THRESHOLD: 'Ngưỡng',
        DECREASE_TO: 'Giảm xuống',
        INCREASE_TO: 'Tăng lên ',
        GOES_ABOVE: 'Trên mức',
        GOES_BELOW: 'Dưới mức',
        CHANGES: 'Thay đổi',
        DECREASE_IN_VALUE: 'Giảm giá trị',
        INCREASE_IN_VALUE: 'Tăng giá trị',
        CHANGES_IN_VALUE: 'Thay đổi giá trị',
        CREDIT_ANY_LEVEL: 'Mức bất kỳ',
        VERY_LOW_RISK: 'Rủi ro rất thấp',
        LOW_RISK: ' Rủi ro thấp',
        MODERATE_RISK: 'Rủi ro trung bình',
        SIGNIFICANT_RISK: 'Rủi ro cao',
        AGRESSIVE_RISK: 'Rủi ro rất cao',
        PERFORMANCE_ANY_LEVEL: 'Mức bất kỳ',
        HIGH_GROWTH: 'Tiềm năng tăng trưởng cao',
        DECENT_GROWTH: 'Tiềm năng tăng trưởng khá',
        MODEST_GROWTH: 'Tiềm năng tăng trưởng khiêm tốn',
        INSIGNIFICANT_GROWTH: 'Tiềm năng tăng trưởng không đáng kể',
        FINANCIAL_RULES: 'Quy tắc tài chính',
        FINANCIAL_RULES_NOTE:
          'Nhận thông báo khi các điều kiện tài chính được đáp ứng.',
        FINANCIAL_INDICATOR: 'Chỉ số tài chính',
        REVENUE_OPERATING_INCOME: 'Doanh thu & Thu nhập hoạt động',
        PROFIT_BEFORE_TAX: 'Lợi nhuận trước thuế',
        APPLY_TO_PORTFOLIOS: 'Thêm vào danh mục',
        APPLY_TO_PORTFOLIOS_NOTE:
          'Chọn một hoặc nhiều danh mục đầu tư bạn muốn áp dụng quy tắc cảnh báo này.',
        PORTFOLIOS: 'Danh mục',
        SELECT_PORTFOLIO: 'Chọn Danh mục',
        SEARCH_PORTFOLIOS_PLH: 'Tìm kiếm tên danh mục',
        SELECTED: 'đã chọn',
        BACK_TO_ALERT_SETTING: 'Quay lại Cài đặt cảnh báo',
        FOLLOWING_LIST_ALERT_NOTE:
          'Danh sách theo dõi là một danh mục đặc biệt với tập hợp các điều kiện cảnh báo riêng biệt, dùng để áp dụng cho các doanh nghiệp trong danh sách này. Bộ tiêu chí này không áp dụng cho các danh mục khác.',
        TRACK_COMPANY_RULES: 'Quy tắc cảnh báo cho danh sách theo dõi',
        TRACK_COMPANY_RULES_NOTE:
          'Bật hoặc tắt chế độ nhận Email cho cảnh báo. Khi tắt chế độ nhận Email, bạn sẽ tiếp tục nhận cảnh báo qua FiinGate.',
        VIEW_ALL_COMPANY_FOLLOWING: 'Xem tất cả công ty bạn đang theo dõi ',
        CLICK_HERE: 'tại đây.',
        criteria: {
          FINANCIAL_DISTRESS: 'Khó khăn tài chính',
          BANKRUPTCY: 'Phá sản',
          FILING_STATUS: 'Tình trạng nợ thuế',
          ANALYSIS_AND_CREDIT_RATINGS: 'Phân tích & Xếp hạng tín dụng',
          BUSSINESS_DISRUPTION: 'Gián đoạn kinh doanh',
          LAWSUIT: 'Kiện tụng',
          LEGAL_VIOLATIONS: 'Vi phạm pháp luật',
          MANAGEMENT_CHANGES: 'Thay đổi quản lý',
          CAPITAL_AND_OWNERSHIP_CHANGES: 'Vốn & Sở hữu',
          EARNING_ANNOUNCEMENT: 'Thông báo thu nhập',
          YEARS_OF_OPERATION: 'Trạng thái doanh nghiệp',
          CORPORATE_CREDIT_RISK_SCORE: 'Điểm rủi ro tín dụng doanh nghiệp',
          CORPORATE_PERFORMANCE_SCORE:
            'Điểm triển vọng tăng trưởng doanh nghiệp',
          TRADE_CREDIT_LIMIT_RECOMMENDATION:
            'Hạn mức tín dụng thương mại được khuyến nghị',
          REVENUE_OPERATION_INCOME: 'Doanh thu & Thu nhập hoạt động',
          PROFIT_BEFORE_TAX: 'Lợi nhuận trước thuế',
          CHANGE_NAME:
            'Thay đổi Tên/ Mã số thuế/ Địa chỉ/ Ngành nghề kinh doanh đăng kí',
          CHANGE_LEGAL_FORM: 'Thay đổi  Hình thức pháp lý',
          CHANGE_LEGAL_REPRESENTATIVE: 'Thay đổi Người đại diện pháp luật',
          CHANGE_ACCOUNTING_PERIOD: 'Thay đổi Năm tài chính',
          UPDATE_FINANCIAL_STATEMENT: 'Cập nhật Báo cáo tài chính',
        },
        PORTFOLIO_TOOLTIP: 'Cài đặt bộ quy tắc cho danh mục ',
        SAVE_CHANGES: 'Lưu Thay Đổi',
        SAVE_CHANGES_CONFIRM_MESS: 'Bạn muốn lưu thay đổi trước khi thoát?',
        WARNING_NO_CRITERIA:
          'Vui lòng cài đặt các tiêu chí cho Quy tắc cảnh báo',
      },
    },
  }),
)
